/**
 * Created by shbs on 20/06/2018.
 */
import API from '../api';
import { parseTime } from '../utils';

export const Partnerada = {
  data () {
    return {
      pageloading: false,
      Form: {
        companyName: '',
        assignment: '',
        linkManEmail1: '',
        linkManEmail2: '',
        country: '',
        country1: '',
        city: '',
        salesName: '',
        salesUserId: '',
        salesTelephone: '',
        contractValidity: '',
        setUpDate: '',
        address: '',
        peopleNumber: '',
        partnerType: '',
        applyReason: '',
        registeredCapital: '',

        parentCompanyName: '',
        parentCompanyCode: '',
        url: '',
        linkMans: [{
          generalManagerName: '',
          position: '',
          telephone: '',
          email: '',
          officePhone: '',
          type: '1'
        }, {
          generalManagerName: '',
          position: '',
          telephone: '',
          email: '',
          officePhone: '',
          type: '3'
        }, {
          generalManagerName: '',
          position: '',
          telephone: '',
          email: '',
          officePhone: '',
          type: '7'
        }, {
          generalManagerName: '',
          position: '',
          telephone: '',
          email: '',
          officePhone: '',
          type: '9'
        }]
      },
      templateId: '',

      ALLuser: [],
      uploadData: {
        type: 'PARTNER'
      },
      AllCountries: [],
      ALLcity: [],
      VADTypeloading: false,
      VADTypelist: [],
      uploadUrl: API.axios.defaults.baseURL + 'common/upload',
      citydisable: true,
      ContractTemplateURL: window.location.origin + API.axios.defaults.baseURL + 'common/templ/',
      accept: 'image/*,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/x-zip-compressed,application/vnd.ms-excel,application/msword,application/x-rar-compressed,application/x-compress,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'
    };
  },
  computed: {
    labelwidth () {
      if (this.$i18n.locale == 'en') {
        return '200px';
      }
      return '130px';
    },
    rules () {
      return {
        companyName: [
          { required: true, message: this.$t('message.needcomName'), trigger: 'blur' }
        ],
        assignment: [
          { type: 'number', required: true, message: this.$t('message.needassignment'), trigger: 'blur' }
        ],
        linkManEmail1: [
          { required: true, message: this.$t('message.needemail'), trigger: 'blur' },
          { type: 'email', message: this.$t('message.needbeemail'), trigger: 'blur' }
        ],
        linkManEmail2: [
          { type: 'email', message: this.$t('message.needbeemail'), trigger: 'blur' }
        ],
        country: [
          { required: true, message: this.$t('message.needecountry'), trigger: 'change' }
        ],
        city: [
          { required: true, message: this.$t('message.needecity'), trigger: 'change' }
        ],
        salesName: [
          { required: true, message: this.$t('message.needesalesName'), trigger: 'blur' }
        ],
        salesTelephone: [
          { required: true, message: this.$t('message.needesalesphone'), trigger: 'blur' }
        ],
        partnerType: [
          { required: true, message: this.$t('message.needepartnerType'), trigger: 'blur' }
        ],
        contractValidity: [
          { required: true, message: this.$t('message.needecontractValidity'), trigger: 'change' }
        ],
        applyReason: [
          { required: true, message: this.$t('message.needeApplicationReason'), trigger: 'blur' }
        ],
        parentCompanyCode: [
          { required: true, message: this.$t('message.needeparentCompanyCode'), trigger: 'blur' }
        ],
        // 编辑需要
        address: [
          { required: true, message: this.$t('message.needeaddress'), trigger: 'blur' }
        ],
        peopleNumber: [
          { required: true, message: this.$t('message.needepeopleNumber'), trigger: 'blur' }
        ],
        setUpDate: [
          { required: true, message: this.$t('message.needesetUpDate'), trigger: 'change' }
        ],
        registeredCapital: [
          { required: true, message: this.$t('message.needRegisteredCapital'), trigger: 'blur' }
        ],
        'linkMans[0].generalManagerName': [
          { required: true, message: this.$t('message.needname'), trigger: 'blur' }
        ],
        'linkMans[0].position': [
          { required: true, message: this.$t('message.needPosition'), trigger: 'blur' }
        ],
        'linkMans[0].telephone': [
          { required: true, message: this.$t('message.needMobile'), trigger: 'blur' }
        ],
        'linkMans[0].email': [
          { required: true, message: this.$t('message.needEmail'), trigger: 'blur' }
        ],

        'linkMans[1].generalManagerName': [
          { required: true, message: this.$t('message.needname'), trigger: 'blur' }
        ],
        'linkMans[1].position': [
          { required: true, message: this.$t('message.needPosition'), trigger: 'blur' }
        ],
        'linkMans[1].telephone': [
          { required: true, message: this.$t('message.needMobile'), trigger: 'blur' }
        ],
        'linkMans[1].email': [
          { required: true, message: this.$t('message.needEmail'), trigger: 'blur' }
        ],

        'linkMans[2].generalManagerName': [
          { required: true, message: this.$t('message.needname'), trigger: 'blur' }
        ],
        'linkMans[2].position': [
          { required: true, message: this.$t('message.needPosition'), trigger: 'blur' }
        ],
        'linkMans[2].telephone': [
          { required: true, message: this.$t('message.needMobile'), trigger: 'blur' }
        ],
        'linkMans[2].email': [
          { required: true, message: this.$t('message.needEmail'), trigger: 'blur' }
        ],
        'linkMans[3].generalManagerName': [
          { required: true, message: this.$t('message.needname'), trigger: 'blur' }
        ],
        'linkMans[3].position': [
          { required: true, message: this.$t('message.needPosition'), trigger: 'blur' }
        ],
        'linkMans[3].telephone': [
          { required: true, message: this.$t('message.needMobile'), trigger: 'blur' }
        ],
        'linkMans[3].email': [
          { required: true, message: this.$t('message.needEmail'), trigger: 'blur' }
        ]
        // "url": [
        //   {required: true, message: this.$t("message.needfile"), trigger: 'blur'},
        // ],
      };
    }

  },
  methods: {
    init () {
      this.pageloading = true;
      API.getAllCountries().then((res) => {
        let json = res.data;
        if (json.status == '200') {
          this.AllCountries = json.data;
          this.$nextTick(() => {
            this.pageloading = false;
          });
        } else {
          this.pageloading = false;
        }
      }).catch(() => {
        this.pageloading = false;
      });
      API.flowtempl(this.Form.partnerType).then((res) => {
        let json = res.data;
        if (json.status == '200') {
          this.templateId = json.data.templateId;
        }
      }).catch(() => {
      });
      API.curruser().then((res) => {
        let json = res.data;
        if (json.status == '200') {
          this.ALLuser.push({ id: 0, userName: json.data.userName, userId: json.data.userId });
          this.Form.salesName = json.data.userName;
          this.Form.salesUserId = json.data.userId;
        }
      }).catch(() => {
      });
    },
    queruser (query) {
      this.VADTypeloading = true;
      if (query !== '') {
        API.getuserslist({
          params: {
            keyword: query,
            userType: 40
          }
        }).then((res) => {
          this.VADTypeloading = false;
          let json = res.data;

          if (json.status == '200') {
            this.ALLuser = json.data;
          } else {
          }
        }).catch(() => {
          this.VADTypeloading = false;
        });
      }
    },
    initCity (id) {
      this.pageloading = true;
      API.getCityByPartentId(id).then((res) => {
        let json = res.data;
        this.pageloading = false;
        if (json.status == '200') {
          this.ALLcity = json.data;
        } else {
        }
      }).catch(() => {
        this.pageloading = false;
      });
    },
    uploadremove (file, fileList) {
      this.Form.url = '';
    },
    uploadsuccess (response, file, fileList) {
      if (response.status == '200') {
        this.Form.url = response.data;
      } else {
        this.$notify.error({
          title: this.$t('message.uploadError')
        });
      }
    },
    uploaderror (response, file, fileList) {
      this.$notify.error({
        title: this.$t('message.uploadError')
      });
    },
    submitadd () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.pageloading = true;

          API.partnerCreat({
            linkMans: [],
            partnerBaseInfo: this.Form,
            url: this.Form.url,
            templateId: this.templateId
          }).then((res) => {
            this.pageloading = false;
            let json = res.data;
            if (json.status == '200') {
              this.$notify({
                title: this.$t('message.submitsuccess'),
                type: 'success'
              });
              this.regist();
              this.$router.push({ name: 'ContractInfolist' });
            } else {
              this.$notify.error({
                title: this.$t('message.submitError')
              });
            }
          }).catch(() => {
            this.$notify.error({
              title: this.$t('message.submitError')
            });
          });
        } else {
          return false;
        }
      });
    },
    citychange (val) {
      this.citydisable = false;

      this.Form.country = this.AllCountries[val].code;
      this.Form.city = '';
      this.initCity(this.AllCountries[val].id);
    },
    remoteVADType (query) {
      if (query !== '') {
        this.VADTypeloading = true;
        API.getvads(query).then((res) => {
          this.VADTypeloading = false;
          let json = res.data;
          if (json.status == '200') {
            this.VADTypelist = json.data;
          }
        }).catch(() => {
          this.VADTypeloading = false;
        });
      }
    },
    salesChange () {
      if (this.$refs.sales) {
        setTimeout(() => {
          this.Form.salesName = this.$refs.sales.selectedLabel;
        }, 100);
      }
    },
    ChangeVADType () {
      if (this.$refs.VADType) {
        setTimeout(() => {
          this.Form.parentCompanyName = this.$refs.VADType.selectedLabel;
        }, 100);
      }
    },
    regist () {
      this.Form.companyName = '';
      this.Form.assignment = '';
      this.Form.linkManEmil1 = '';
      this.Form.linkManEmil2 = '';
      this.Form.country = '';
      this.Form.city = '';
      this.Form.salesName = '';
      this.Form.salesTelephone = '';
      this.Form.contractValidity = '';
      this.Form.url = '';
      if (this.$refs['uploadref']) {
        this.$refs['uploadref'].clearFiles();
      }
    }

  }
};

export const formate = {
  methods: {
    parseTime (time, fromat) {
      return parseTime(time, fromat);
    },
    getApprovalstate (key) {
      let map = {
        '1': this.$t("Approvalstate['1']"),
        '-1': this.$t("Approvalstate['-1']"),
        '0': this.$t("Approvalstate['0']")
      };
      return map[key];
    },
    getNodeStateName (index, nodeList) {
      try {
        if (nodeList.length) {
          let name = nodeList[index - 1].stepName;
          return name;
        }
      } catch (e) {

      }
    },
    getUTCtime (row) {
      if (row) {
        let sysDate = new Date(row);
        let offset = sysDate.getTimezoneOffset() * 1000 * 60;
        let loacltime = sysDate.getTime() - offset;
        return parseTime(loacltime, '{y}-{m}-{d}');
      }
      return '';
    },
    formatDate (date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + '';
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : this.padLeftZero(str));
        }
      }
      return fmt;
    },
    padLeftZero (str) {
      return ('00' + str).substr(str.length);
    }
  }
};
